<!-- 输入预约信息 -->
<template>
  <div class="home">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('InputInfo.title')"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <van-field
      v-model="name"
      :label="$t('InputInfo.name')"
      clearable
      :placeholder="$t('InputInfo.inputName')"
    />
    <van-field
      v-model="phone"
      clearable
      :label="$t('InputInfo.phone')"
      :placeholder="$t('InputInfo.inputPhone')"
    />
    <van-field
      v-model="meal_number"
      clearable
      :label="$t('InputInfo.maelNum')"
      :placeholder="$t('InputInfo.inputMealNum')"
    />
    <van-cell :title="$t('InputInfo.gender')">
      <van-radio-group solt="right-icon" v-model="gender">
        <van-radio class="selSex" :name="0">
          {{ $t("InputInfo.woman") }}
          <img
            width="20px"
            height="20px"
            slot="icon"
            slot-scope="props"
            :src="
              props.checked
                ? './static/img/sele.png'
                : './static/img/unsele.png'
            "
          />
        </van-radio>
        <van-radio class="selSex" :name="1">
          {{ $t("InputInfo.man") }}
          <img
            width="20px"
            height="20px"
            slot="icon"
            slot-scope="props"
            :src="
              props.checked
                ? './static/img/sele.png'
                : './static/img/unsele.png'
            "
          />
        </van-radio>
      </van-radio-group>
    </van-cell>
    <van-field
      :value="date | formatDate1"
      :label="$t('InputInfo.bookdate')"
      :placeholder="$t('InputInfo.bookdate')"
      readonly
      right-icon="arrow"
      @click="isMealDateShow = true"
    />
    <van-popup v-model="isMealDateShow" position="bottom">
      <van-datetime-picker
        v-model="date"
        :minDate="currentDate"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
        type="date"
        @cancel="isMealDateShow = false"
        @confirm="onConfirmMealDate"
      />
    </van-popup>
    <van-field
      v-model="meal_time"
      :label="$t('InputInfo.bookMealTime')"
      :placeholder="$t('InputInfo.bookMealTime')"
      readonly
      right-icon="arrow"
      @click="isMealTimeShow = true"
    />
    <van-popup v-model="isMealTimeShow" position="bottom">
      <van-datetime-picker
        v-model="meal_time"
        type="time"
        :min-hour="0"
        :max-hour="23"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
        @cancel="isMealTimeShow = false"
        @confirm="onConfirmMealTime"
      />
    </van-popup>
    <van-button
      style="width: 90%;height: 35px;margin-left: 5%;margin-top: 50px;line-height: 35px;"
      color="#2f75f4"
      round
      @click="createReserve()"
      >{{ $t("InputInfo.submit") }}</van-button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      store_id: "",
      name: "",
      phone: "",
      meal_number: "",
      gender: 0,
      date: "",
      meal_time: "",
      currentDate: new Date(),
      isMealDateShow: false,
      isMealTimeShow: false,
      id: ""
    };
  },
  filters: {
    formatDate1(value) {
      if (!value) {
        return "";
      } else {
        var date = new Date(value);
        var Y = date.getFullYear() + "-";
        var M = date.getMonth() + 1 + "-";
        var D = date.getDate();
        return Y + M + D;
      }
    }
  },
  methods: {
    onConfirmMealDate(value, index) {
      this.date = value;
      this.isMealDateShow = false;
    },
    onConfirmMealTime(value, index) {
      this.mealTime = value;
      this.isMealTimeShow = false;
    },
    // 创建预约
    createReserve() {
      if (
        this.name &&
        this.phone &&
        this.date &&
        this.meal_time &&
        this.meal_number
      ) {
        this.$axios({
          method: "post",
          headers: {
            code: sessionStorage.code
          },
          url: this.$build + "/api/book/customerStore",
          data: {
            store_id: sessionStorage.getItem("storeId"),
            name: this.name,
            phone: this.phone,
            gender: this.gender,
            date: this.date,
            meal_time: this.meal_time,
            meal_number: this.meal_number
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.id = res.data.data.id;
              sessionStorage.setItem("id", this.id);
              // this.$toast({
              //     type:'success',
              //     message:res.data.message,
              // });
              const vm = this;
              setTimeout(function() {
                vm.$router.push("/Result");
              }, 500);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("common.message")
            });
          });
      } else {
        this.$toast(this.$t("common.toast"));
      }
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
.van-button__text {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.selSex {
  min-width: 50px;
  float: right;
}
/deep/ .van-cell {
  line-height: 36px;
}
.home {
  padding-top: 46px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-field__label {
  width: 105px;
}
</style>



// WEBPACK FOOTER //
// src/reserve/InputInfo.vue